import {
  ActionStore,
  createAction, KeyStore,
  on, ParamsStore,
  RemoteObjectStore,
  SOFTLINE_SERVICE_UUID,
  SOFTLINE_STORE_OBJECT_SERVICE, SOFTLINE_STORE_REMOTE_OBJECT_SERVICE, StoreBuilder,
  StoreFeature, SyncedRemoteObjectStore,
} from '@softline/core';
import {DailyBalance} from '../data/daily-balance';

export interface State extends RemoteObjectStore.State<DailyBalance> {}

class DailyBalanceStoreExtension {
  static actions = {
    getDailyBalance: createAction<State, { date: string }, DailyBalance>('getDailyBalance')
  };

  static feature: Partial<StoreFeature<State>> = {
    actions: [
      on(DailyBalanceStoreExtension.actions.getDailyBalance, async ({featureName, injector, params, commit}) => {
        const service = injector.get(SOFTLINE_STORE_REMOTE_OBJECT_SERVICE);
        const token = injector.get(SOFTLINE_SERVICE_UUID)();
        commit(featureName, KeyStore.mutations.add, token);
        commit(featureName, ParamsStore.mutations.add, {key: token, params});

        const observable = service.get(params);
        const result = await ActionStore.handleObservableActionState(
          observable, featureName, commit, DailyBalanceStoreExtension.actions.getDailyBalance.name, token
        ).toPromise();
        commit(featureName, SyncedRemoteObjectStore.mutations.set, result);
        return result;
      })
    ]
  };
}

export const DailyBalanceStore = new StoreBuilder(RemoteObjectStore.create<DailyBalance>())
  .add(KeyStore)
  .add(ParamsStore)
  .add(DailyBalanceStoreExtension)
  .value;
